import { ApexAccountDetails } from '../../../investment/components/account/ApexAccountDetails';

export default function AccountDetailsPage() {
    return <ApexAccountDetails />;
}
